import { render } from "./TVSuccess.vue?vue&type=template&id=1211711f&scoped=true"
import script from "./TVSuccess.vue?vue&type=script&lang=js"
export * from "./TVSuccess.vue?vue&type=script&lang=js"

import "./TVSuccess.vue?vue&type=style&index=0&id=1211711f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1211711f"]])

export default __exports__